import Vue from 'vue';
import Vuex from 'vuex';
import * as state from './mutations.js';
import * as major from './major.js';
import * as vote from './vote.js';
import company from './company.js';
import exportFile from './exportFile.js';
import album from './album';
import comment from './comment';
import userPower from './userPower';
import dialog from './dialog.js';
import userManage from './userManage';
import worker from './worker.js';
import activeDomain from './activeDomain';
import { user, errors, saas, fluxStorageSpace } from '../services';
import { ROLES_ENUM } from '@/constant';
import serviceAccount from './serviceAccount';
// import { activityMediaLib, errors } from '../services';
import dateFormat from 'ourwill-feutil/common/dateFormat';
import timejudge from '@/utils/timejudge';
import config from '@/services/config';
import { managerRoles, liveManagerRoles } from '@/constant/constantMap.js';

Vue.use(Vuex);

const userInfoModule = {
	state: {
		nickname: '',
		avatarUrl: '',
		user: { id: '', mobPhone: '', info: '', certification: null, couponUnread: 0 },
		level: '',
		maxCapacity: '100GB',
		curCapacity: '0GB',
		capacityFull: false, // 容量是否已满
		expiryDate: '',
		saveFlag: false,
		btnFlag: false,
		cerTipsShow: false,
		maxFlux: '不限',
		curFlux: '0GB',
		surplusSize: '0GB', // 用户剩余流量
		fluxWarning: false, // 流量是否已满
		fluxPercentage: 0, // 已用流量百分比
		isUnlimitedUser: 0, // 是否不限流量
		fluxList: [], // 流量授权列表

		// 定制营销裂变用户ID
		// 测试环境 14849478 - 李宏吉
		// 线上环境
		// 34491364 -- 定制用户
		// 31619516 -- 李宏吉
		// 189 -- 林吉炫
		// 35442807 -- 徐昭
		// 502246 -- 冯红贤
		customCompanyFissionList: config.key === 'v1' ? [189, 34491364, 31619516, 502246] : [14849478],
	},
	mutations: {
		setNickname(state, nickname) {
			state.nickname = nickname;
		},
		setAvatarUrl(state, avatarUrl) {
			state.avatarUrl = avatarUrl;
		},
		setUser(st, data) {
			st.user = data;
		},
		setLevel(st, data) {
			st.level = data;
		},
		setMaxCapacity(state, data) {
			state.maxCapacity = data;
		},
		setCurCapacity(state, data) {
			state.curCapacity = data;
		},
		setCapacityFull(state, status) {
			state.capacityFull = status;
		},
		setExpiryDate(state, data) {
			state.expiryDate = data;
		},
		setSaveFlag(state, data) {
			state.saveFlag = data;
		},
		setBtnFlag(state, data) {
			state.btnFlag = data;
		},
		setCerTipsShow(state, data) {
			state.cerTipsShow = data;
		},
		setFlagshipRemainingTimes(state, data) {
			console.log(data, 9999);
			state.user.userEmpower.flagshipRemainingTimes = data;
		},
		setFullviewRemainingTimes(state, data) {
			state.user.userEmpower.fullviewRemainingTimes = data;
		},
		SET_MAX_FLUX(state, data) {
			state.maxFlux = data;
		},
		SET_CUR_FLUX(state, data) {
			state.curFlux = data;
		},
		SET_FLUX_FULL(state, status) {
			state.fluxWarning = status;
		},
		SET_SURPLUS_SIZE(state, data) {
			state.surplusSize = data;
		},
		SET_IS_UNLIMITED_USER(state, status) {
			state.isUnlimitedUser = status;
		},
		SET_FLUX_LIST(state, list) {
			state.fluxList = list;
		},
		SET_FLUX_PERCENTAGE(state, num) {
			state.fluxPercentage = num;
		},
	},
	actions: {
		getUser({ state }) {
			return state.user;
		},
		async saveUser({ commit, dispatch }, params) {
			try {
				// debugger
				const { data, ok } = await user.getUserInfo(params);
				if (!ok) {
					// console.log(data)
					// this._vm.$ws(false, +new Date());	登录失败情况跳转，不进行登录失败逻辑
					return;
				}
				commit('setNickname', data.data.nickname ? data.data.nickname : data.data.username);
				commit('setAvatarUrl', data.data.avatarUrl);
				commit('setLevel', data.data.level);
				commit('setUser', data.data);
				if (data.data.userType === 3) {
					commit('company/SET_ROLEIDS', liveManagerRoles);
				}
				// if (data.data.roles.includes(ROLES_ENUM.SUB_MANAGE)) {
				// 	commit('company/SET_ROLEIDS', managerRoles);
				// } else
				// ws需要用带上用户id的标识，这里ev不需要变，只需要id。
				this._vm.$ws(false, data.data.id);

				sessionStorage.setItem('user', JSON.stringify(data.data));
				// await dispatch('getCompanyList');
				const companyInfo = await dispatch('company/getCompanyInfo');
				const userId = companyInfo && companyInfo.loginUserId ? companyInfo.loginUserId : data.data.id;
				dispatch('userPower/getUserPowerType', userId);
				// do what you want
				return {
					userInfo: data.data,
					companyInfo,
				};
			} catch (e) {
				errors(e);
			}
		},
		async getTotalFlux({ commit }, params) {
			try {
				const { data, ok } = await fluxStorageSpace.getTotalFlux();
				if (!ok) {
					return;
				}
				commit('SET_MAX_FLUX', data.data.total);
				commit('SET_CUR_FLUX', data.data.useSize);
				commit('SET_IS_UNLIMITED_USER', data.data.isUnlimitedUser);
				commit('SET_SURPLUS_SIZE', data.data.surplusSize);
				commit('SET_FLUX_FULL', data.data.warning);
				commit('SET_FLUX_LIST', data.data.list);
				commit('SET_FLUX_PERCENTAGE', data.data.percent);
			} catch (error) {
				errors(error);
			}
		},
	},
	getters: {
		isAdmin(state) {
			return state.level && state.level >= 1;
		},
		isFlagCompany(state) {
			return (
				state.user &&
				state.user.userEmpower &&
				state.user.userEmpower.flagshipCompanyDueDate &&
				state.user.userEmpower.flagshipCompanyDueDate > +new Date()
			);
		},
		isFullviewCompany(state) {
			return (
				state.user &&
				state.user.userEmpower &&
				state.user.userEmpower.fullviewCompanyDueDate &&
				state.user.userEmpower.fullviewCompanyDueDate > +new Date()
			);
		},
		// 本账号是否有企业版
		isCompany(state, getters) {
			return getters.isFlagCompany || getters.isFullviewCompany;
		},
		onlyRetoucher(state) {
			//管理员roles为空
			if (!state.user || !state.user.roles || !state.user.roles.length) {
				return false;
			}
			let hasPower = [ROLES_ENUM.SUB_MANAGE, ROLES_ENUM.LIVE_MANAGE, ROLES_ENUM.LIVE_PUBLISH];
			let len = new Set([...hasPower, ...state.user.roles]).size;
			if (len === state.user.roles.length + hasPower.length) {
				return true;
			}
			return false;
		},
		userEmpower(state, getters) {
			return state.user && state.user.userEmpower ? state.user.userEmpower : {};
		},

		isFree(state, getters) {
			if (getters.isMajor || getters.isFlagship || getters.isFullview || getters.isCompany) {
				return false;
			}
			return true;
		},
		isFlagship(state, getters) {
			if (getters.flagshipDue || getters.flagshipNum) {
				return true;
			}
			return false;
		},
		flagshipDue(state, getters) {
			if (!state.user.id || !getters.userEmpower.flagshipType) {
				return '';
			}
			if (getters.userEmpower.flagshipDueDate && timejudge(getters.userEmpower.flagshipDueDate)) {
				return `${dateFormat(getters.userEmpower.flagshipDueDate, 'YYYY-MM-DD')}`;
			}
			return '';
		},
		flagshipNum(state, getters) {
			if (!state.user.id || !getters.userEmpower.flagshipRemainingTimes) {
				return '';
			}
			return getters.userEmpower.flagshipRemainingTimes;
		},
		isMajor(state, getters) {
			if (getters.majorDue || getters.majorNum) {
				return true;
			}
			return false;
		},
		majorDue(state, getters) {
			if (!state.user.id || !getters.userEmpower.professionalType) {
				return '';
			}
			if (getters.userEmpower.professionalDueDate && timejudge(getters.userEmpower.professionalDueDate)) {
				return `${dateFormat(getters.userEmpower.professionalDueDate, 'YYYY-MM-DD')}`;
			}
			if (getters.flagshipDue) {
				return getters.flagshipDue;
			}
			return '';
		},
		majorNum(state, getters) {
			if (!state.user.id) {
				return '';
			}
			return getters.userEmpower.professionalRemainingTimes ? getters.userEmpower.professionalRemainingTimes : '';
		},
		isFullview(state, getters) {
			if (getters.fullviewNum || getters.fullviewDueDate) {
				return true;
			}
			return false;
		},
		fullviewNum(state, getters) {
			if (!state.user.id || !getters.userEmpower.fullviewRemainingTimes) {
				return '';
			}
			return getters.userEmpower.fullviewRemainingTimes;
		},
		fullviewDueDate(state, getters) {
			if (
				!state.user.id ||
				!getters.userEmpower.fullviewDueDate ||
				!timejudge(getters.userEmpower.fullviewDueDate)
			) {
				return '';
			}
			return dateFormat(getters.userEmpower.fullviewDueDate, 'YYYY-MM-DD');
		},
	},
};

const store = new Vuex.Store({
	modules: {
		state,
		userInfo: userInfoModule,
		major,
		vote,
		exportFile,
		album,
		company,
		serviceAccount,
		userPower,
		dialog,
		userManage,
		worker,
		comment,
		activeDomain,
	},
});

if (module.hot) {
	// 使 actions 和 mutations 成为可热重载模块
	module.hot.accept(['./mutations'], () => {
		// 获取更新后的模块
		// 因为 babel 6 的模块编译格式问题，这里需要加上 .default
		const newMutations = require('./mutations').default;
		// 加载新模块
		store.hotUpdate({
			mutations: newMutations,
		});
	});
}

export default store;
